import React, { useContext } from 'react';

export const DEFAULT_ENTRY = {
    id: null,
    name: null,
    metaData: {},
    hasEntered: false
};

export const EntryContext = React.createContext({
    entry: DEFAULT_ENTRY,
    setEntry: () => {}
});

export const useEntry = () => useContext(EntryContext);
